import React, { useEffect, useRef, useState } from "react";
import hljs from "highlight.js";

import { updateShippingApi } from "../../apiHelper/authService";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { clearSelectedPackage, clearSelectedShippingCharge } from "../../redux/authModalSlice";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
const UpdateShipCharges = () => {
    const navigate = useNavigate()

    const { selectedShippingCharge } = useSelector((state) => state.authModal);
    const { user } = useSelector((state) => state.authModal);
    const fromCountry = user?.from;
    const toCountry = user?.to;

    const [shippingId , setShippingId] = useState('')


    const dispatch = useDispatch()

    useEffect(() => {
        // Load highlight.js configuration and signal when ready
        hljs?.configure({
            languages: [
                "javascript",
                "ruby",
                "python",
                "java",
                "csharp",
                "cpp",
                "go",
                "php",
                "swift",
            ],
        });
    }, []);


   
  


    const [intCharges, setIntCharges] = useState('');
    const [locCharges, setLocCharges] = useState('');
    const [taxes, setTaxes] = useState('');


    const [selectedUnit, setSelectedUnit] = useState("AIR");







    

  

    const handleSubmit = async (e) => {
        e.preventDefault();

        const payloadData = {
            Order_charges_type: "SHIPMENT",
            international_courier_charge: Number(intCharges),
            local_delivery_charge: Number(locCharges),
            shipping_charges_type: selectedUnit,
            taxes: Number(taxes),
            // id: shippingId,





        }

        try {
            const res = await updateShippingApi(shippingId,payloadData);
            console.log('Success:', res);
            toast.success(res.message || "Success")
            navigate("/shipment-charges")


        } catch (err) {
            toast.error(err || "Something went wrong")

            console.error('Error:', err);
        }


    };



    useEffect(() => {
        if (selectedShippingCharge) {

     
            setShippingId(selectedShippingCharge?.id || '')
            setIntCharges(selectedShippingCharge?.international_courier_charge || '')
            setLocCharges(selectedShippingCharge?.local_delivery_charge || '')
            setTaxes(selectedShippingCharge?.taxes || "")
            setSelectedUnit(selectedShippingCharge?.shipping_charges_type || '')




          



           



        }

        return () => {

            dispatch(clearSelectedShippingCharge());
        };
    }, [selectedShippingCharge, dispatch]);

 
    function getTotalVal(taxPercent, internationCharge, localCharge) {
        const international = Number(internationCharge);
        const local = Number(localCharge);
        const tax = Number(taxPercent);

        const subtotal = international + local;
        const taxAmount = (subtotal * tax) / 100;
        const total = subtotal + taxAmount;

        return Number(total.toFixed(2)); // Optional: rounds to 2 decimal places
    }


    const handleNumericInput = (e, setter) => {
        const value = e.target.value;

        if (/^\d*\.?\d*$/.test(value)) {
            setter(value);
        }
    };


    return (
        <div className='row gy-4'>
            <div className='col-lg-12'>
                <div className='card mt-24'>
                    <div className='card-header border-bottom'>
                        <h6 className='text-xl mb-0'>Update Shipping Charges</h6>
                    </div>
                    <div className='card-body p-24'>
                        <form onSubmit={handleSubmit} className='d-flex flex-column gap-20'>

                            <div className="row">
                                <div className="col-12 col-md-4 mb-3">
                                    <label className='form-label fw-bold text-neutral-900' htmlFor='intCharges'>
                                        International Charges:
                                    </label>
                                    <input
                                        type='text'
                                        required
                                        className='form-control border border-neutral-200 radius-8'
                                        id='sizeName'
                                        placeholder='Enter Applicable International Charges'
                                        value={intCharges}
                                        // onChange={(e) => setIntCharges(e.target.value)}
                                           onChange={(e) => handleNumericInput(e, setIntCharges)}

                                    />
                                </div>

                                <div className="col-12 col-md-4 mb-3">
                                    <label className='form-label fw-bold text-neutral-900' htmlFor='sizeLength'>
                                        Local Charges:
                                    </label>
                                    <input
                                        type='text'
                                        required
                                        className='form-control border border-neutral-200 radius-8'
                                        id='sizeLength'
                                        placeholder='Enter Applicable Local Charges'
                                        value={locCharges}
                                        // onChange={(e) => setLocCharges(e.target.value)}
                                           onChange={(e) => handleNumericInput(e, setLocCharges)}

                                    />
                                </div>

                                <div className="col-12 col-md-4 mb-3">
                                    <label className='form-label fw-bold text-neutral-900' htmlFor='sizeWidth'>
                                        Taxes (%):
                                    </label>
                                    <input
                                        type='text'
                                        required
                                        className='form-control border border-neutral-200 radius-8'
                                        id='sizeWidth'
                                        placeholder='Enter Applicable Tax Percent'
                                        value={taxes}
                                        // onChange={(e) => setTaxes(e.target.value)}
                                           onChange={(e) => handleNumericInput(e, setTaxes)}

                                    />
                                </div>
                            </div>








                            <div className="row">

                                <div className="col-md-6 col-12">

                                    <label className='form-label fw-bold text-neutral-900' htmlFor='sizeName'>

                                        Shipment Type
                                    </label>

                                    <div className="dropdown">
                                        <button
                                            className="btn btn-primary-600 bg-primary-50 border-primary-50 text-primary-600 hover-text-primary not-active px-18 py-11 dropdown-toggle toggle-icon"
                                            type="button"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            {selectedUnit}
                                        </button>

                                        <ul className="dropdown-menu">
                                            <li>
                                                <button
                                                    type="button"
                                                    className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                                    onClick={() => setSelectedUnit("AIR")}
                                                >
                                                    AIR
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    type="button"

                                                    className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                                    onClick={() => setSelectedUnit("SHIP")}
                                                >
                                                    SHIP
                                                </button>
                                            </li>
                                        </ul>
                                    </div>

                                </div>

                            </div>

                            <div className="row">




                                <div className="col-12 col-md-3 mb-3">
                                    <label className='form-label fw-bold text-neutral-900' htmlFor='ecomAir'>
                                        Total:
                                    </label>
                                    <input
                                        disabled

                                        type='text'
                                        required
                                        className='form-control border border-neutral-200 radius-8'
                                        id='ecomAir'

                                        placeholder='Auto-calculated'
                                        value={getTotalVal(taxes, intCharges, locCharges)}
                                        readOnly
                                    />
                                </div>
                            </div>





                            <button type='submit' className='btn btn-primary-600 radius-8 col-md-2'>
                                Submit
                            </button>
                        </form>
                    </div>
                </div>
            </div>
 

        </div>
    );
};

export default UpdateShipCharges;
